<div id="wrapper">
    <div
        *ngIf="isRefreshingDetails"
        style="position: fixed; inset: 0; background: rgba(255, 255, 255, 0.7); z-index: 9999; display: flex; align-items: center; justify-content: center;"
    >
        <app-loader></app-loader>
    </div>

    <app-navbar></app-navbar>

    <app-sidebar [isCondensed]="isCondensed"></app-sidebar>

    <div class="content-page">
        <div class="content">
            <div class="content-pane">
                <div class="container-fluid">
                    <div class="breadcrumb">
                        <span class="breadcrumb-item">
                            <a href="javascript:void(0)">PayEXAP</a>
                        </span>
                        <span class="px-2">
                            <i class="ri-arrow-right-s-line"></i>
                        </span>
                        <span class="breadcrumb-item" aria-current="page">
                            <a routerLink="/change-requests">Change Requests</a>
                        </span>
                    </div>

                    <div class="row negative-margin">
                        <div class="col-md-12">
                            <app-jsw-auth-banner></app-jsw-auth-banner>

                            <div
                                *ngIf="errorMsg && !(jswAuthFailed$ | async)"
                                class="alert alert-danger session-text text-center"
                                role="alert"
                            >
                                {{ errorMsg }}
                            </div>

                            <div
                                *ngIf="!(jswAuthFailed$ | async)"
                                class="card manage-invoice"
                            >
                                <div class="card-body">
                                    <div class="pane-header mb-3">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <h4 class="mt-2">Change Requests</h4>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="actions-pane float-end mt-2">
                                                    <button
                                                        type="button"
                                                        class="btn btn-invoice"
                                                        (click)="onCreateChangeRequest()"
                                                        [disabled]="!canCreateChangeRequest"
                                                        [title]="changeRequestCreateButtonTitle"
                                                    >
                                                        <i class="ri-add-line me-1"></i>
                                                        Change Request
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="search-pane">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="download-pane float-end d-flex align-items-center gap-3">
                                                    <i
                                                        class="ri-refresh-line"
                                                        title="Refresh"
                                                        (click)="!loading && load()"
                                                        [style.opacity]="loading ? 0.45 : 1"
                                                        [style.pointer-events]="loading ? 'none' : 'auto'"
                                                    ></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="table-responsive">
                                        <div class="loader text-center" *ngIf="loading">
                                            <app-loader></app-loader>
                                        </div>

                                        <ng-container *ngIf="!loading">
                                            <div
                                                *ngIf="collectionSize === 0 && !errorMsg"
                                                class="text-center py-5"
                                            >
                                                <img
                                                    src="assets/images/empty-state.png"
                                                    alt="No-data"
                                                />
                                                <h1 class="card-title my-2">
                                                    No Change Requests Available
                                                </h1>
                                                <p class="card-text">
                                                    There is no available data to show yet
                                                </p>
                                            </div>

                                            <ng-container *ngIf="records.length > 0">
                                                <table
                                                    aria-describedby="change-requests-list"
                                                    class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint purchase-orders text-nowrap"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th scope="col" style="text-align: center !important">
                                                                Request ID
                                                            </th>
                                                            <th scope="col" style="text-align: center !important">
                                                                MDRM Request No.
                                                            </th>
                                                            <th scope="col" style="text-align: center !important">
                                                                Record No.
                                                            </th>
                                                            <th scope="col" style="text-align: center !important">
                                                                Creation Date
                                                            </th>
                                                            <th scope="col" style="text-align: center !important">
                                                                Status
                                                            </th>
                                                            <th scope="col" style="text-align: center !important">
                                                                Updated Fields
                                                            </th>
                                                            <th scope="col" style="text-align: center !important">
                                                                Actions
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            *ngFor="let row of records"
                                                            style="text-align: center;"
                                                        >
                                                            <td class="cr-stg-no">{{ row._id || '-' }}</td>
                                                            <td>{{ row.mdrmInProcessReqNo || '-' }}</td>
                                                            <td>{{ row.recordNo || '-' }}</td>
                                                            <td>{{ (row.createdAt | date:'dd-MMM-yyyy HH:mm') || '-' }}</td>
                                                            <td class="text-center align-middle">
                                                                <span class="align-middle">{{ row.status || '-' }}</span>
                                                                <button
                                                                    *ngIf="hasStatusComment(row)"
                                                                    type="button"
                                                                    class="btn btn-sm p-0 ms-1 align-middle text-info cr-status-comment-btn"
                                                                    placement="top"
                                                                    [ngbTooltip]="statusCommentTooltip(row)"
                                                                    [attr.aria-label]="'Status comment: ' + statusCommentTooltip(row)"
                                                                >
                                                                    <i class="ri-information-line" aria-hidden="true"></i>
                                                                </button>
                                                            </td>
                                                            <td>
                                                                <span class="me-2">
                                                                    {{ countOfChangedFields(row) }} field(s) changed
                                                                </span>
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-sm btn-outline-primary"
                                                                    (click)="openStgColumnDetails(row)"
                                                                    [disabled]="countOfChangedFields(row) === 0"
                                                                >
                                                                    <i class="ri-eye-line me-1"></i>
                                                                    View
                                                                </button>
                                                            </td>
                                                            <td>
                                                                <span
                                                                    *ngIf="isRequestRejected(row)"
                                                                    class="d-inline-block"
                                                                    placement="top"
                                                                    [ngbTooltip]="editRequestButtonTitle(row)"
                                                                >
                                                                    <button
                                                                        type="button"
                                                                        class="btn btn-sm btn-outline-secondary"
                                                                        (click)="editRejectedRequest(row)"
                                                                        [disabled]="loading || !canCreateChangeRequest"
                                                                    >
                                                                        <i class="ri-pencil-line me-1"></i>
                                                                        Edit Request
                                                                    </button>
                                                                </span>
                                                                <span *ngIf="!isRequestRejected(row)" class="text-muted">—</span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </ng-container>
                                            <div
                                                *ngIf="collectionSize > 0 && records.length === 0 && !errorMsg"
                                                class="text-center py-4 text-muted"
                                            >
                                                No change requests on this page.
                                            </div>
                                            <div class="table-footer py-3" *ngIf="collectionSize > 0">
                                                <div class="row">
                                                    <div class="col-sm-5">
                                                        <label
                                                            class="d-inline-flex align-items-center mb-3"
                                                        >
                                                            Show
                                                            <select
                                                                id="cr-show-entries"
                                                                class="form-select form-select-sm mx-1"
                                                                [(ngModel)]="pageSize"
                                                                (ngModelChange)="onListPageSizeChange()"
                                                            >
                                                                <option [ngValue]="10">10</option>
                                                                <option [ngValue]="15">15</option>
                                                                <option [ngValue]="25">25</option>
                                                                <option [ngValue]="50">50</option>
                                                                <option [ngValue]="100">100</option>
                                                            </select>
                                                            entries
                                                        </label>
                                                    </div>
                                                    <div class="col-sm-7">
                                                        <div class="text-end">
                                                            <ngb-pagination
                                                                class="d-flex justify-content-end"
                                                                [collectionSize]="collectionSize"
                                                                [(page)]="page"
                                                                [pageSize]="pageSize"
                                                                [maxSize]="4"
                                                                [rotate]="true"
                                                                [ellipses]="false"
                                                                [boundaryLinks]="true"
                                                                (pageChange)="onListPageChange()"
                                                            ></ngb-pagination>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #stgColumnModal let-modal>
    <div class="modal-header cr-updated-fields-modal-header">
        <h5 class="modal-title">Updated Fields</h5>
        <button
            type="button"
            class="btn-close btn-close-white"
            aria-label="Close"
            (click)="modal.dismiss()"
        ></button>
    </div>
    <div class="modal-body">
        <div
            *ngIf="stgColumnEntries().length === 0"
            class="text-muted text-center"
        >
            No field changes recorded for this request.
        </div>

        <ul class="cr-stg-list list-unstyled mb-0">
            <li *ngFor="let entry of stgColumnEntries()" class="mb-3">
                <ng-container *ngIf="!entry.isArray">
                    <div class="cr-stg-key">{{ entry.key }}</div>
                    <div class="cr-stg-value">{{ entry.value }}</div>
                </ng-container>

                <ng-container *ngIf="entry.isArray">
                    <div class="cr-stg-key">{{ entry.key }}</div>
                    <div
                        *ngFor="let item of asArray(entry.value); let i = index"
                        class="cr-stg-array-item mt-2"
                    >
                        <div class="cr-stg-array-index">#{{ i + 1 }}</div>
                        <ul class="list-unstyled mb-0 ms-3">
                            <li *ngFor="let kv of bankRowEntries(item)">
                                <span class="cr-stg-subkey">{{ kv.key }}:</span>
                                <span class="ms-1">{{ kv.value }}</span>
                            </li>
                        </ul>
                    </div>
                </ng-container>
            </li>
        </ul>

        <h6 class="cr-stg-documents-title mt-4 mb-2">Uploaded documents</h6>
        <ul
            *ngIf="selectedUploadedDocumentNames.length"
            class="cr-stg-documents-list list-unstyled mb-0"
        >
            <li *ngFor="let name of selectedUploadedDocumentNames" class="cr-stg-document-name">
                {{ name }}
            </li>
        </ul>
        <p
            *ngIf="!selectedUploadedDocumentNames.length"
            class="text-muted small mb-0"
        >
            No documents recorded.
        </p>
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-secondary"
            (click)="modal.dismiss()"
        >
            Close
        </button>
    </div>
</ng-template>
